import React from 'react';
import GeckoFieldBase from '../_base.jsx';

class GeckoFieldText extends GeckoFieldBase {
  render() {
    return (
      <input
        id={this.renderId()}
        className="col-sm form-control gecko-ui-material"
        type="text"
        disabled={this.isDisabled()}
        value={this.value()}
        onChange={this.handleChange.bind(this)}
        placeholder={this.config().placeholder || this.field().placeholder}
        onBlur={this.handleBlur.bind(this)}
      />
    );
  }
}

export default GeckoFieldText;
